"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.selectChildren = exports.initialValues = exports.icon = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _shuffle2 = _interopRequireDefault(require("lodash/shuffle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = ['name', 'randomizeChildren', 'childrenLimitType', 'childrenLimit'];
exports.fields = fields;
var initialValues = {
  name: 'Block',
  randomizeChildren: false,
  childrenLimitType: 'all',
  childrenLimit: 10
};
exports.initialValues = initialValues;
var icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-th-large"
});
exports.icon = icon;
var validate = function validate(values) {
  var errors = {};
  if (['number', 'percent'].includes(values.childrenLimitType)) {
    if (!values.childrenLimit || typeof values.childrenLimit !== 'number' || values.childrenLimit < 1 || values.childrenLimit > 100) {
      errors.childrenLimit = 'The value should be between 1 and 100';
    }
  }
  return errors;
};
exports.validate = validate;
var selectChildren = function selectChildren(ids, settings) {
  var childrenLimitType = settings.childrenLimitType,
    childrenLimit = settings.childrenLimit,
    randomizeChildren = settings.randomizeChildren;
  var limit = Infinity;
  if (childrenLimitType === 'number') {
    limit = childrenLimit;
  } else if (childrenLimitType === 'percent') {
    limit = Math.ceil(childrenLimit / 100 * ids.length);
  }
  var hasLimit = limit < ids.length;
  if (!randomizeChildren && !hasLimit) {
    return null;
  }
  if (randomizeChildren) {
    ids = (0, _shuffle2["default"])(ids);
    if (hasLimit) {
      return ids.slice(0, limit);
    }
  }
  if (hasLimit) {
    var positions = (0, _shuffle2["default"])(ids.map(function (_, index) {
      return index;
    })).slice(0, ids.length - limit);
    ids = _toConsumableArray(ids);
    positions.forEach(function (index) {
      ids[index] = null;
    });
    return ids.filter(function (id) {
      return id !== null;
    });
  }
  return ids;
};
exports.selectChildren = selectChildren;